// extracted by mini-css-extract-plugin
export default {"notify":"notify_notify__bWXLb","notifyMounted":"notify_notifyMounted__QDmHj","notifyExitBtn":"notify_notifyExitBtn__dyHOP","notifyContent":"notify_notifyContent__EnuaW"};